import { render } from "./BaseRadio.vue?vue&type=template&id=158da514"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Inputs/BaseRadio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "158da514"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('158da514', __exports__)) {
    api.reload('158da514', __exports__)
  }
  
  module.hot.accept("./BaseRadio.vue?vue&type=template&id=158da514", () => {
    api.rerender('158da514', render)
  })

}


export default __exports__